import { motion, AnimatePresence, useAnimate } from "motion/react";
import { useState, useEffect } from "react";
import { useResponsive } from "../utils/responsiveContext";

export const TickerText = ({ text, skills, className }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isMobile } = useResponsive();
  const [scope, animate] = useAnimate();

  // Fixed velocity in pixels per second - adjust this value
  const VELOCITY = 200; // pixels per second (higher = faster)

  useEffect(() => {
    if (scope.current && isHovered && !isMobile) {
      const width = scope.current.offsetWidth / 5; 
      const duration = width / VELOCITY;

      animate(
        scope.current,
        { x: [0, -width] },
        {
          duration,
          ease: "linear",
          repeat: Infinity,
        }
      );
    }
  }, [scope, animate, isHovered, isMobile, skills, VELOCITY]);
  return (
    <div
      className={`relative ${className} w-full`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        transform: "translateZ(0)",
        willChange: "transform",
        display: "inline-block",
        minWidth: "fit-content",
      }}
    >
      {/* Static text - always present to maintain height */}
      <div
        className="whitespace-nowrap w-full"
        style={{
          opacity: !isHovered || isMobile ? 1 : 0,
          transition: "opacity 0.1s ease",
        }}
      >
        {text}
      </div>

      {/* Marquee overlay */}
      <AnimatePresence>
        {isHovered && !isMobile && (
          <motion.div
            key="ticker"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.3,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="absolute top-0 left-0 overflow-hidden bg-white text-black rounded-lg"
            style={{
              backfaceVisibility: "hidden",
              WebkitBackfaceVisibility: "hidden",
              width: "max-content",
              minWidth: "100%",
            }}
          >
            <div
              ref={scope}
              className="inline-flex whitespace-nowrap"
              style={{
                willChange: "transform",
                transform: "translateZ(0)",
                backfaceVisibility: "hidden",
                WebkitBackfaceVisibility: "hidden",
              }}
            >
              <span className="px-2 inline-block">{skills}</span>
              <span className="px-2 inline-block">{skills}</span>
              <span className="px-2 inline-block">{skills}</span>
              <span className="px-2 inline-block">{skills}</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
